/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { CardFooter } from 'reactstrap';

const ExplainText = ({ data }) => {
  const renderExpainText = (explain) => {
    const { audioScript, text } = explain;
    return (
      <div>
        <div>
          {audioScript &&
            <div>
              <h3>Audio script:</h3>
              {audioScript
                .replace(/<Girl>/gi, '')
                .replace(/<\/Girl>/gi, '')
                .replace(/<Woman>/gi, '')
                .replace(/<\/Woman>/gi, '')
                .replace(/<Man>/gi, '')
                .replace(/<\/Man>/gi, '')
                .replace(/<Boy>/gi, '')
                .replace(/<\/Boy>/gi, '')
                .split('</br>')
                .map((item, index) => {
                  return (
                    <div key={index}>{item}</div>
                  );
                })}
            </div>}
        </div>
        <div>
          {
            text &&
            <div>
              <h3>Giải thích: </h3>
              {text.split('</br>').map((item, index) => {
                return <div key={index}>{item}</div>;
              })}
            </div>
          }
        </div>
      </div>
    );
  };
  return data?.explainText ?
    <CardFooter>
      {renderExpainText(data?.explainText)}
    </CardFooter> : null;
};

ExplainText.propTypes = {

};

export default ExplainText;
